import type { SaleDetail, SaleDetailItem, SaleDetailDiscount, SaleDetailPayment } from '../domain/salesTypes';
import { fetchRemoteSaleDetail, isOnline } from '../../reports/infra/reportsRemoteRepo';

export type { SaleDetail, SaleDetailItem, SaleDetailDiscount, SaleDetailPayment };

export const getSaleDetail = async (saleId: string): Promise<SaleDetail | null> => {
  try {
    if (await isOnline()) {
      const remote = await fetchRemoteSaleDetail(saleId);
      if (remote) return remote;
    }
  } catch {
    /* ignore */
  }
  return null;
};

export async function getSalePaymentTotals(
  _saleId: string
): Promise<{ nonCustomerPaid: number; customerAllocationPaid: number }> {
  return {
    nonCustomerPaid: 0,
    customerAllocationPaid: 0,
  };
}

export async function getCustomerNameById(_customerId: string): Promise<string | null> {
  return null;
}
